import { isSmall } from 'frontend-library/src/utilities/js/mediaQueries';
// collapse help section widgets on mobile
(function ($) {
    if (isSmall()) {
        $(".helpSection__widgets .js-collapseOnMobile").toggle();
        $('.js-togglerCollapseOnMobile').click(function () {
            $(this).next('.js-collapseOnMobile').slideToggle();
        });
    }
    else {
        $(".helpSection__widgets .js-collapseOnMobile:hidden").show();
    }
})(jQuery);
